import {
  LOAD_SUCCESS_JOURNALS,
  LOAD_FAIL_JOURNALS,
  SAVE_SUCCESS_JOURNALS,
  SAVE_FAIL_JOURNALS,
  UPDATE_SUCCESS_JOURNALS,
  UPDATE_FAIL_JOURNALS,
  DELETE_SUCCESS_JOURNALS,
  DELETE_FAIL_JOURNALS,
} from "../actions/journalAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_JOURNALS:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_JOURNALS:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_JOURNALS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_JOURNALS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_JOURNALS:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.journal_id === action.payload.journal_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_JOURNALS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_JOURNALS:
      const filtered = state.data.filter((item) => {
        return item.journal_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_JOURNALS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
